import request from '@/utils/request'

export function findProfileDatas(params) {
  return request({
    url: `/profile_datas`,
    method: 'get',
    params
  })
}

export function importProfileDatas(data) {
  return request({
    url: `/profile_datas/import`,
    method: 'post',
    data
  })
}

export function exportProfileDatas(data) {
  return request({
    url: `/profile_datas/export`,
    method: 'post',
    data
  })
}

export function destroyProfileDatas(data) {
  return request({
    url: `/profile_datas`,
    method: 'delete',
    data
  })
}

export function generateProfilesFromProfileDatas(data) {
  return request({
    url: `/profile_datas/generate_profiles`,
    method: 'post',
    data
  })
}

export function findSmdpPlatforms() {
  return request({
    url: `/profile_datas/smdp_platforms`,
    method: 'get'
  })
}
